import { SVG } from '../svg';
import { IconProps } from '../types';

export function ChevronUpIcon(props: IconProps): JSX.Element {
  return (
    <SVG {...props}>
      <path d="m18 15-6-6-6 6" />
    </SVG>
  );
}
